import { Component } from '@angular/core';
import { PlaygroundComponent } from '@app/components/playground/playground.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    imports: [PlaygroundComponent, TranslateModule]
})
export class FaqComponent {
}
